import { render, staticRenderFns } from "./VisualizarLeilao.vue?vue&type=template&id=06279e68&"
import script from "./VisualizarLeilao.vue?vue&type=script&lang=js&"
export * from "./VisualizarLeilao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports